var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M768 640v99.6c0 8.1-2.1 14.2-8.2 20.3-6.2 6.2-12.1 8.1-20.2 8.1-120.1-2.1-260.1-40.3-351.6-131.8S258.1 404.5 256 284.4c0-8.1 2-14.1 8.1-20.2s12.1-8.2 20.3-8.2H384l25.6 153.6-47.8 62.1c14.2 40.3 42.7 83.1 75.1 115.6 32.5 32.5 75.1 60.7 115.3 74.9l62.1-47.8L768 640z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.dbab7c76330cba326babc82350ee6004.svg";
export { ForwardRef as ReactComponent };